/* eslint-disable func-names */

import * as yup from 'yup';

export const newClientContractValidationSchema = yup.object({
  client_id: yup
    .string('Select a client')
    .required('Client is required')
    .max(100, `Client can't be more than 100 characters`),
  covered_entity: yup
    .string('Enter covered entity name')
    .required('Covered entity name is required')
    .max(100, `Covered entity name can't be more than 100 characters`),
  practice_name: yup
    .string('Enter practice name')
    .required('Practice name is required')
    .max(100, `Practice name can't be more than 100 characters`),
  phone: yup
    .string('Enter phone number')
    .required('Phone number is required')
    .max(20, `Phone number can't be more than 20 characters`),
  address: yup
    .string('Enter address')
    .required('Address is required')
    .max(200, `Address can't be more than 200 characters`),
  fee_type: yup
    .string('Select fee type')
    .required('Fee type is required')
    .oneOf(['Percentage', 'Fixed Monthly'], 'Invalid fee type'),
  percentage_terms: yup
    .number('Enter the percentage term')
    .test('percentage_terms', 'Percentage term is required', function (value) {
      const feeType = this.resolve(yup.ref('fee_type'));
      if (feeType === 'Percentage') {
        return value !== undefined && value !== null && value >= 0 && value <= 99;
      }
      return true;
    }),
  fixed_monthly_fee: yup
    .number('Enter the fixed monthly fee')
    .test('fixed_monthly_fee', 'Fixed monthly fee is required', function (value) {
      const feeType = this.resolve(yup.ref('fee_type'));
      if (feeType === 'Fixed Monthly') {
        return value !== undefined && value !== null && value > 0;
      }
      return true;
    }),
  percentage_fee_description: yup
    .string()
    .test('percentage_fee_description', 'Please enter fee description', function (value) {
      const feeType = this.resolve(yup.ref('fee_type'));
      if (feeType === 'Percentage') {
        return value && value.trim() !== '';
      }
      return true;
    }),
  services: yup.array().min(1, 'Please select at least one service').of(yup.string(), 'Invalid service option'),
  activation_date: yup.date('Enter the activation date').nullable().required('Activation date is required'),
  include_associate_name: yup.boolean().default(false),
  associate_name: yup.string().test('associate_name', 'Please enter entity name', function (value) {
    const associateIncluded = this.resolve(yup.ref('include_associate_name'));
    if (associateIncluded) {
      return value !== undefined;
    }
    return true;
  }),
  additional_services: yup
    .array()
    .test('additional_services', 'Please type the name of the additional service', function (value) {
      const additionalServicesEnabled = this.resolve(yup.ref('additional_services_enabled'));
      if (additionalServicesEnabled) {
        return value && value.length > 0 && value.every((service) => service && service.trim() !== '');
      }
      return true;
    })
    .of(yup.string().nullable()),
  credentialing_per_provider_enabled: yup.boolean().default(false),
  credentialing_per_provider_fee: yup
    .number('Enter credentialing fee')
    .test('credentialing_fee', 'Credentialing fee is required', function (value) {
      const enabled = this.resolve(yup.ref('credentialing_per_provider_enabled'));
      if (enabled) {
        return value !== undefined && value !== null && value > 0;
      }
      return true;
    }),
  prior_authorization_enabled: yup.boolean().default(false),
  prior_authorization_flat_fee: yup
    .number('Enter prior authorization fee')
    .test('prior_auth_fee', 'Prior authorization fee is required', function (value) {
      const enabled = this.resolve(yup.ref('prior_authorization_enabled'));
      if (enabled) {
        return value !== undefined && value !== null && value > 0;
      }
      return true;
    }),
  special_project_rate_enabled: yup.boolean().default(false),
  special_project_rate_per_hour: yup
    .number('Enter special project rate')
    .test('special_project_rate', 'Special project rate is required', function (value) {
      const enabled = this.resolve(yup.ref('special_project_rate_enabled'));
      if (enabled) {
        return value !== undefined && value !== null && value > 0;
      }
      return true;
    }),
  other_fee_enabled: yup.boolean().default(false),
  other_service_fee_field_name: yup
    .string('Enter service name')
    .test('other_fee_name', 'Service name is required', function (value) {
      const enabled = this.resolve(yup.ref('other_fee_enabled'));
      if (enabled) {
        return value && value.trim() !== '';
      }
      return true;
    }),
  other_service_fee_field_value: yup
    .number('Enter service fee')
    .test('other_fee_value', 'Service fee is required', function (value) {
      const enabled = this.resolve(yup.ref('other_fee_enabled'));
      if (enabled) {
        return value !== undefined && value !== null && value > 0;
      }
      return true;
    }),
});
